export default "__VITE_ASSET__DqZr0JMe__"